angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/progressbar/progress.html",
    "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
}]);



//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-bootstrap/template/progressbar/progress.html.js
// module id = 1203
// module chunks = 1